<template>
  <div class="tasks">
    <div class="level table-actions">
      <div class="level-left">
        <form @submit.prevent="loadData">
          <div class="field is-grouped controls">
            <div class="control">
              <b-input v-model="q" :placeholder="$t('interface.search')"></b-input>
            </div>
            <div class="control">
              <button type="submit" class="button is-primary">
                <b-icon icon="magnify" size="is-small"></b-icon>
              </button>
            </div>
          </div>
        </form>
      </div>
      <div class="level-right" v-if="(isAuthor && ['draft', 'new', 'in_process'].includes(detail.state))
                                     || (isExecutiveMaintainer && detail.state === 'in_process')">
        <div class="field is-grouped controls">
          <div class="control mb-10">
            <button @click="goTo('createTask')"
                    class="button is-success">
              {{ $t('tasks.create') }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="field is-grouped controls mt-20 is-multiline">
      <div class="control">
        <b-switch v-model="filters.show_my_tasks">{{ $t('tasks.showMy') }}</b-switch>
      </div>
      <div class="control">
        <b-switch v-model="filters.show_expired_tasks">{{ $t('tasks.showExpired') }}</b-switch>
      </div>
    </div>
    <div class="columns mt-10 is-multiline">
      <div class="column is-3" v-for="task in list">
        <article @click="view(task.id)" :class="`message is-${stateColors[task.state]}`">
          <!--<div class="message-header">
            &lt;!&ndash;<button @click="remove(task.id)"
                    class="delete"
                    aria-label="delete"></button>&ndash;&gt;
          </div>-->
          <div class="message-body">
            <h3 class="title is-6 mb-10">{{ $t('routes.taskDetail') }} #{{task.id}}</h3>
            {{task.description}}
            <div class="option-item" v-if="task.executors.length > 0">
              <div v-for="executor in task.executors">
                <div :label="executor.initials" class="executor">
                  <div class="image is-20x20">
                    <img v-if="executor.thumb" :src="executor.thumb" class="is-rounded">
                    <img v-else src="../assets/user.svg" class="is-rounded">
                  </div>
                  <div class="name">{{ executor.initials }}</div>
                </div>
              </div>
            </div>
          </div>
        </article>
      </div>
      <div class="column is-12">
        <section class="section" v-if="list.length === 0">
          <div class="content is-fluid has-text-grey has-text-centered">
            <p>{{ $t('interface.nothingFound') }}
              <a class="is-dashed" @click.prevent="resetFilters">{{ $t('interface.resetFiltersAndSearch') }}</a>.
            </p>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import {stateColors} from "@/colorTypes"
  import BSwitch from "buefy/src/components/switch/Switch";

  const filtersDefault = {
    show_expired_tasks: false,
    show_my_tasks: false
  }

  export default {
    components: {BSwitch},
    data() {
      return {
        data: [],
        q: '',
        filters: {...filtersDefault},
        stateColors
      }
    },
    methods: {
      view(id) {
        this.$router.push({
          name: 'taskDetail',
          params: {
            taskId: id,
            documentId: this.detail.id
          }
        })
      },
      goTo(route) {
        this.$router.push({name: route})
      },
      remove(id) {
        this.$axios.delete(`workflow/documents/${this.detail.id}/tasks/${id}/`).then(() => {
          this.loadData()
        })
      },
      loadData() {
        this.$store.dispatch('Task/list', {
          documentId: this.detail.id,
          params: {
            q: this.q,
            ...this.filters
          }
        })
      },
      resetFilters() {
        this.q = ''
        this.filters = {...filtersDefault}
      }
    },
    computed: {
      ...mapState('Document', ['detail']),
      ...mapState('Task', ['list']),
      ...mapState('Account', ['account']),
      isAuthor() {
        return this.detail.author.id === this.account.employee.id
      },
      isExecutiveMaintainer() {
        return this.detail.executive_maintainer ? this.detail.executive_maintainer.id === this.account.employee.id : false
      }
    },
    watch: {
      filters: {
        handler() {
          this.loadData()
        },
        deep: true
      }
    }
  }
</script>

<style lang="scss" scoped>
  .description {
    margin-bottom: 5px;
  }

  .option-item {
    margin-top: 16px;
  }

  .executor {
    background: #fff;
    display: inline-block;
    padding: 4px 8px;
    border-radius: 4px;
    border-bottom: 1px solid #d1d1d1;
    margin-bottom: 4px;

    .image, .name {
      display: inline-block;
    }
    .image {
      vertical-align: top;
      margin-right: 8px;
    }
  }

  .message {
    cursor: pointer;

    a {
      text-decoration: none !important;
      font-weight: normal;
    }

    .message-body {
      padding: 10px 15px;
      border-bottom: 1px solid #d1d1d1;
      font-size: 14px;
    }
  }
</style>
